<div class="d-flex">
  <div class="document-buttons">
    <div id="btn-general" class="document-button general selected">
      <button type="submit" class="btn-documents">
        <i class="icon-user"></i>
        {{ "forms.buttons.new" | translate }}
      </button>
    </div>
  </div>

  <div class="card w-100 form-right">

    <div class="back">
      <div class="div-title">
        <h2>
          {{ edit ? ("forms.names.editUser" | translate) : ("forms.names.addUser" | translate) }}
        </h2>
      </div>
      <i class="icon-cross2" (click)="emitBackButtonClick()"></i>
    </div>

    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-section mb-3">

          <div class="row mb-3">
            <div class="col-12">
              <div class="mb-3">
                <label for="roles" class="form-label">{{ "inputs.roles" | translate }}
                  <span class="required">*</span>
                </label>
                <div class="position-relative">
                  <div class="input-group">
                  <select id="roles" class="form-control" formControlName="roles">
                    <option value="" disabled selected>{{ "inputs.select_option" | translate }}</option>
                    <option value="Agent">{{ "inputs.Agent" | translate }}</option>
                    <option value="Supervisor">{{ "inputs.Supervisor" | translate }}</option>
                    <option value="Admin">{{ "inputs.Admin" | translate }}</option>
                    <option [hidden]="account_type !== 'broker'" value="Sales">{{ "inputs.Sales" | translate }}</option>
                    <option [hidden]="account_type !== 'supplier'" value="Pre-sales">{{ "inputs.PreSales" | translate }}
                    </option>
                    <option [hidden]="account_type !== 'supplier'" value="Workshop">{{ "inputs.Workshop" | translate }}
                    </option>
                    <option [hidden]="account_type !== 'supplier'" value="Logistics">{{ "inputs.Logistics" | translate }}
                    </option>
                    <option [hidden]="account_type !== 'supplier'" value="Telemarketing">{{ "inputs.telemarketing" | translate }}
                    </option>
                  </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row linea"></div>


          <div class="row mb-3">
            <div class="col-6" *ngIf="form.get('type')?.value !== 'organization'">
              <div class="mb-3">
                <label for="vendor" class="form-label">{{ "inputs.name" | translate }}
                  <span class="required">*</span>
                </label>
                <input id="vendor" class="form-control" formControlName="name"
                  placeholder="  {{ 'inputs.name' | translate }}" />
              </div>
            </div>
            <div class="col-6" *ngIf="form.get('type')?.value !== 'organization'">
              <div class="mb-3">
                <label for="lastname" class="form-label">{{ "inputs.lastname" | translate }} <span class="required">*</span></label>
                <input id="lastname" class="form-control" formControlName="lastname"
                  placeholder=' {{ "inputs.lastname" | translate }}' />
              </div>
            </div>
          </div>

          <div class="row linea"></div>

          <div class="row mb-3">
            <div class="col-12">
              <div class="mb-3">
                <label for="supplier" class="form-label">{{ "inputs.email" | translate }}
                  <span class="required">*</span></label>
                <input id="email" class="form-control" formControlName="email"
                  placeholder=' {{ "inputs.email" | translate }}' />
              </div>
              <div *ngIf="isFieldInvalid('email')">
                <small *ngIf="getFormError('email', 'required')" class="error_validation">El correo es
                  obligatorio.</small>
                <small *ngIf="getFormError('email', 'email')" class="error_validation">El formato del correo es
                  inválido.</small>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-4">
              <div class="mb-3">
                <label for="phone_prefix" class="form-label">{{ "inputs.phone_prefix" | translate }}
                </label>
                <app-select-country-prefix (changePrefix)="changePrefix($event)"
                  [selectedPrefix]="form.get('phonePrefix')?.value"
                  [selectionMode]="'prefix'"></app-select-country-prefix>
              </div>
            </div>

            <div class="col-8">
              <div class="mb-3">
                <label for="phone" class="form-label">{{ "inputs.phone" | translate }}
                </label>
                <input id="phone" class="form-control phone-number" formControlName="phoneNumber" type="tel"
                  placeholder="{{ 'inputs.phone' | translate }}" (input)="onInput($event)" />
              </div>
              <div *ngIf="form.hasError('invalidPhoneNumber') && form.get('phoneNumber')?.touched">
                <small class="error_validation">Si el prefijo es +34, el número debe tener 9 dígitos.</small>
              </div>

              <div *ngIf="isFieldInvalid('phoneNumber')">
                <small class="error_validation">El teléfono debe tener 9 dígitos, o si empieza con +34, debe tener 9
                  dígitos adicionales.</small>
              </div>
            </div>
          </div>
          <!-- SMTP Mailbox selector -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="mb-3">
                <label for="account_smtp" class="form-label">{{ "settings.mail.mailboxes.select_mailbox" | translate }}</label>
                <div class="input-group">
                <select id="account_smtp" class="form-control" formControlName="account_smtp">
                  <option value="" disabled selected>{{ "inputs.select_option" | translate }}</option>
                  <option *ngFor="let mailbox of mailboxes" [ngValue]="mailbox.reference">
                    {{ mailbox.label }} ({{ mailbox.from_address }})
                  </option>
                </select>
                </div>
              </div>
            </div>
          </div>

          <!-- VoIP Line selector -->
          <div class="row mb-3" *ngIf="voipLines.length > 0">
            <div class="col-12">
              <div class="mb-3">
                <label for="account_voip" class="form-label">{{ "communication.voip.voip_lines" | translate }}</label>
                <div class="input-group">
                <select id="account_voip" class="form-control" formControlName="account_voip">
                  <option [ngValue]="null">{{ "inputs.select_option" | translate }} (Default)</option>
                  <option *ngFor="let line of voipLines" [ngValue]="line.reference">
                    {{ line.label }} ({{ line.caller_id }})
                  </option>
                </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row linea"></div>
          <!-- <div *ngIf="edit" class="row mb-3">
            <label for="" class="form-label">{{
              "inputs.refresh_password" | translate
              }}</label>
            <div class="col-6">
              <div class="button-create-container">
                <button type="submit" class="btn btn-primary btn-primary-form create-button">
                  {{ "buttons.refresh_password" | translate }}
                </button>
              </div>
            </div>
          </div> -->
          <!-- <div class="row linea"></div> -->

          <!-- <div *ngIf="edit" class="row mb-3">
            <label for="" class="form-label">{{
              "inputs.current_password_text" | translate
              }}</label>
            <div class="col-6">
              <div class="mb-3">
                <label for="current_password" class="form-label">{{
                  "inputs.current_password" | translate
                  }}</label>
                <input id="current_password" class="form-control" type="current_password" formControlName="current_password" placeholder="{{
                                          'inputs.current_password' | translate
                                        }}" />
              </div>
            </div>

          </div>

          <div class="row mb-3">
            <div class="col-6">
              <div class="mb-3">
                <label for="password" class="form-label">{{
                  "inputs.password" | translate
                  }}</label>
                <input id="password" class="form-control" type="password" formControlName="password" placeholder="{{
                                          'inputs.password' | translate
                                        }}" />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="password_confirmation" class="form-label">{{
                  "inputs.password_confirmation" | translate
                  }}</label>
                <input id="password_confirmation" class="form-control" type="password" formControlName="password_confirmation" placeholder="{{
                                                          'inputs.password_confirmation' | translate
                                                        }}" />
              </div>
            </div>
          </div> -->
          <!-- <div class="row linea"></div>-->

          <div *ngIf="edit" class="button-create-container">
            <button type="submit" class="btn btn-primary btn-primary-form create-button">
              {{ "buttons.update_user" | translate }}
            </button>
          </div>

          <div *ngIf="!edit" class="button-create-container">
            <button type="submit" class="btn btn-primary btn-primary-form create-button">
              {{ "buttons.create_user" | translate }}
            </button>
          </div>
        </div>
        <!-- </form> -->
      </form>
    </div>

  </div>

</div>
